export const AdminWorkSectionController = {
    index(): void {},
    sync(): void {},
    toggle(): void {},
    toggleHidden(): void {},
    order(): void {},
};
